<template>
  <div class="sliderPointerPosition">
      <div>
        <v-layout row class="sliderPointerContainer">
          <v-flex class="flexGrow0" @click="$emit('input',0)"></v-flex>
          <v-flex class="flexGrow1 start" @click="$emit('input',0)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '0'"></div></div></v-flex>
          <v-flex class="flexGrow2" @click="$emit('input',1)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '1'"></div></div></v-flex>
          <v-flex class="flexGrow2" @click="$emit('input',2)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '2'"></div></div></v-flex>
          <v-flex class="flexGrow2" @click="$emit('input',3)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '3'"></div></div></v-flex>
          <v-flex class="flexGrow2" @click="$emit('input',4)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '4'"></div></div></v-flex>
          <v-flex class="flexGrow2" @click="$emit('input',5)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '5'"></div></div></v-flex>
          <v-flex class="flexGrow2" @click="$emit('input',6)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '6'"></div></div></v-flex>
          <v-flex class="flexGrow2" @click="$emit('input',7)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '7'"></div></div></v-flex>
          <v-flex class="flexGrow2" @click="$emit('input',8)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '8'"></div></div></v-flex>
          <v-flex class="flexGrow2" @click="$emit('input',9)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '9'"></div></div></v-flex>
          <v-flex class="flexGrow1 end" @click="$emit('input',10)"><div><div class="pointer" :class="'color' + (received ? 'Received' : 'Gived') + '10'"></div></div></v-flex>
          <v-flex class="flexGrow0" @click="$emit('input',10)"></v-flex>
        </v-layout>
      </div>
    </div>
</template>
<script>
export default {
  name: 'SliderPointers',

  components: {},

  data: () => ({
    debug: false,

    test: []
  }),

  props: {
    value: {
      type: Number
    },
    received: {
      type: Boolean,
      default: false
    }
  },

  computed: {},

  watch: {},

  created() {},

  methods: {}
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.sliderPointerPosition {
  position: relative;
}
.sliderPointerPosition > div {
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 0;
}
.sliderPointerContainer,
.flex {
  padding: 0 !important;
  margin: 0 !important;
}
.sliderPointerContainer > .flex {
  height: 88px;
  display: flex;
  justify-content: center;
  padding-top: 40px !important;
}
.sliderPointerContainer > .flex.start {
  justify-content: flex-start;
}
.sliderPointerContainer > .flex.end {
  justify-content: flex-end;
}
.sliderPointerContainer > .flex > div {
  width: 0;
  height: 0;
}
.flexGrow0 {
  flex-grow: 0;
  width: 24px;
}
.flexGrow1 {
  flex-grow: 1;
}
.flexGrow2 {
  flex-grow: 2;
}
.pointer {
  position: relative;
  left: -12px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
}
.colorGived0 {
  background-color: rgba(11,59,94,0.1);
}
.colorGived1 {
  background-color: rgba(11,59,94,0.19);
}
.colorGived2 {
  background-color: rgba(11,59,94,0.28);
}
.colorGived3 {
  background-color: rgba(11,59,94,0.37);
}
.colorGived4 {
  background-color: rgba(11,59,94,0.46);
}
.colorGived5 {
  background-color: rgba(11,59,94,0.55);
}
.colorGived6 {
  background-color: rgba(11,59,94,0.64);
}
.colorGived7 {
  background-color: rgba(11,59,94,0.73);
}
.colorGived8 {
  background-color: rgba(11,59,94,0.82);
}
.colorGived9 {
  background-color: rgba(11,59,94,0.91);
}
.colorGived10 {
  background-color: rgba(11,59,94,1.0);
}
.colorReceived0 {
  background-color: rgba(255,42,82,0.1);
}
.colorReceived1 {
  background-color: rgba(255,42,82,0.19);
}
.colorReceived2 {
  background-color: rgba(255,42,82,0.28);
}
.colorReceived3 {
  background-color: rgba(255,42,82,0.37);
}
.colorReceived4 {
  background-color: rgba(255,42,82,0.46);
}
.colorReceived5 {
  background-color: rgba(255,42,82,0.55);
}
.colorReceived6 {
  background-color: rgba(255,42,82,0.64);
}
.colorReceived7 {
  background-color: rgba(255,42,82,0.73);
}
.colorReceived8 {
  background-color: rgba(255,42,82,0.82);
}
.colorReceived9 {
  background-color: rgba(255,42,82,0.91);
}
.colorReceived10 {
  background-color: rgba(255,42,82,1.0);
}
</style>